var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"probability"},[_c('div',{staticClass:"probability__text"},[_vm._v("Probabilidad de que se gane el Parlay:")]),_c('div',{staticClass:"probability__percent"},[_c('div',[_vm._v(_vm._s(_vm.percent)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }